import packageJson from '../../package.json';

export const environment = {
  production: false,
  version: packageJson.version,
  pageSize: 50,
  email: 'arantxa.salgado@daimlertruck.com',
  TOKEN: 'jwt',
  REFRESH_TOKEN: 'refreshToken',
  DEALERS_SITE:
    'https://qa-dealers.daimlertruck-financialservices.mx/SitioDistribuidoresB/app/home/home.zul?',
  API_AUTH_SERVICE: 'https://dealers-back-qa.bshouse.io/auth-service/api/v1',
  API_DEALEARS_SERVICE:
    'https://dealers-back-qa.bshouse.io/dealer-service/api/v1',
  API_NOTIFICATION_SERVICE:
    'https://dealers-back-qa.bshouse.io/notification-service/api/v1',
  API_USER_SERVICE: 'https://dealers-back-qa.bshouse.io/user-service/api/v1',
  API_WHOLESALE_SERVICE:
    'https://dealers-back-qa.bshouse.io/wholesale-service/api/v1',
  API_PROCOTIZA:
    'https://qa-ms.daimlertruck-financialservices.mx/middleware/telepro/v1/refresh-token',
  API_MAILSHOT_SERVICE:
    'https://dealers-back-qa.bshouse.io/mailshot-service/api/v1',
  API_FILE_SERVICE: 'https://dealers-back-qa.bshouse.io/file-service/api/v1',
  API_QUOTE_SERVICE: 'https://dealers-back-qa.bshouse.io/quote-service/api/v1',
  API_CREDIT_REQUEST_SERVICE: 'https://dealers-back-qa.bshouse.io/credit-request-service/api/v1',
  API_CREDIT_REQUEST_SERVICE_V2: 'https://dealers-back-qa.bshouse.io/credit-request-service/api/v2',
  API_MARKETING_SERVICE: 'https://dealers-back-qa.bshouse.io/marketing-service/api/v1',
  activarDiro: true,
  testDiro: false,
  API_DIRO_SERVICE:
    'https://dealers-back.daimlertruck-financialservices.mx/diro-service/api/v1',
  API_CLIENTS_SERVICE: 'https://dealers-back-qa.bshouse.io/customer-service/api/v1',
  downloadJson: true,
  optimizationQuote: false,
  ACTIVE_PRODUCT_BALLON: true,
  ACTIVE_PRODUCT_CAPITAL_LOAN: true,
  ACTIVE_PRODUCT_REAL_STATE: true,
  active_audit_history_dealers: true,
  active_client_catalog: true,
  active_accesories_marsh: true,
  active_payment_fixed: true,
  activate_calculate_v2: true,
  active_disable_company_change: true,
  useAccountStatesComponent: true,
  usePlanPisoFilter: true,
  activeQuoteListValidStatusFilter: true,
  showQuoteValidityListFilter: true,
  quoteListValidStatusDefault: null as boolean | null,
  showFinancialSetupQuoteValidityDays: true,
  useDescargasMenuAreaSplit: true,
  featureLoyaltyFeriaQuotation: true,
  mailshotRecipientsImprovements: true,
  QA_HIDE_ONBOARDING: false,
  HIDE_DRM_REGION: false,
  METAMAP_ACTIVE: true,
  /**
   * Versión del reporte de calidad 036. En `true` usa v2 (endpoint
   * `/api/v2`, Excel de 4 hojas); en `false` o sin valor usa v1
   * (producción, solo la hoja `detail`). Se retira cuando negocio
   * apruebe v2.
   */
  QUALITY_KPI_SHEETS_ACTIVE: true,
  /**
   * PFAE también con los regímenes 625 y 626. En `false` solo
   * el 612 es PFAE. Ticket en pausa: solo local/dev por ahora.
   */
  PFAE_EXTENDED_TAX_REGIMES_ACTIVE: false,
};
